import { AxiosInstance } from 'axios'
import { z } from 'zod'

export const NodeInputOptionsResponseSchema = z.array(
  z.object({ name: z.string(), label: z.string(), description: z.string().optional(), disabled: z.boolean().optional() })
)
export type NodeInputOption = z.infer<typeof NodeInputOptionsResponseSchema>[number]

export default class NodesApi {
  constructor(private client: AxiosInstance) {}
  getAllNodes = (params?: Record<string, any>) => this.client.get('/nodes', { params })

  getSpecificNode = (name: string) => this.client.get(`/nodes/${name}`)

  getInputOptions = (name: string, inputName: string, inputs: Record<string, unknown>) =>
    this.client.post(`/nodes/${encodeURIComponent(name)}/input-options/${encodeURIComponent(inputName)}`, { inputs })
}
